import React from 'react';
import {
    Box,
    Button,
    Modal,
    Typography,
    Paper,
    IconButton
} from '@mui/material';
import {
    Close,
    CheckCircle
} from '@mui/icons-material';

const SuccessModal = ({ open, onClose, ticketId }: { open: boolean; onClose: () => void; ticketId?: string }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="success-modal"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2
            }}
        >
            <Paper
                sx={{
                    width: '100%',
                    maxWidth: '400px',
                    borderRadius: '12px',
                    bgcolor: '#fff',
                    boxShadow: 24,
                    p: 0,
                    overflow: 'hidden'
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        px: 3,
                        py: 1,
                        borderBottom: '1px solid #EEEBF7',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end'
                    }}>

                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            color: '#6B7280',
                            '&:hover': {
                                bgcolor: '#F3F4F6'
                            }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Box>

                {/* Content */}
                <Box sx={{ p: 3, textAlign: 'left' }}>
                    {/* Success Icon */}
                    <CheckCircle
                        sx={{
                            fontSize: '64px',
                            color: '#10B981',
                            mb: 1
                        }}
                    />

                    {/* Success Message */}
                    <Typography className='gray-900' sx={{ fontSize: '1.25rem', fontWeight: 600, mb: 1 }}>
                        Ticket created successfully
                    </Typography>

                    {/* Ticket ID */}
                    <Box
                        sx={{  
                            bgcolor: '#F3F4F6', 
                            px: 2, 
                            py: 1, 
                            borderRadius: '8px'
                        }}
                    >
                        <Typography
                            fontSize="1rem"
                            sx={{ 
                                mb: 0.5
                            }}
                        >
                            Ticket ID:
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '1rem',
                                fontWeight: 600,
                                color: '#1F2937',
                                fontFamily: 'monospace'
                            }}
                        >
                            {ticketId}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Modal>
    );
};

export default SuccessModal;